import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowUpRight, ArrowDown, CarFront } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { photoById } from "@/data/portfolio";

export default function Hero() {
  const { t } = useLanguage();
  const reduced = useReducedMotion();
  const desktop = photoById("apartment-06");
  const mobile = photoById("apartment-14");
  const enter = delay => ({ initial: reduced ? false : { opacity: 0, y: 16 }, animate: { opacity: 1, y: 0 }, transition: { duration: reduced ? 0 : 0.65, delay: reduced ? 0 : delay, ease: [0.22, 1, 0.36, 1] } });
  return <section data-testid="hero-section" className="studio-hero">
    <picture className="absolute inset-0">
      <source media="(max-width: 639px)" srcSet={mobile.srcSet} sizes="100vw" />
      <img data-testid="hero-work-image" src={desktop.full} srcSet={desktop.srcSet} sizes="100vw" width={desktop.width} height={desktop.height}
        alt="Shylov Cleaning" fetchPriority="high" className="hero-work-photo" />
    </picture>
    <div className="hero-photo-scrim" />
    <div className="studio-container relative z-10 w-full">
      <motion.p {...enter(0.05)} className="text-cyan-200 text-xs sm:text-sm font-medium mb-5">Nice · Cannes · Monaco</motion.p>
      <motion.h1 {...enter(0.12)} data-testid="hero-heading" className="text-4xl sm:text-5xl lg:text-6xl leading-[1.12] font-heading font-semibold text-white max-w-xl">
        Shylov<br /><span className="font-accent italic font-normal">Cleaning.</span>
      </motion.h1>
      <motion.p {...enter(0.2)} className="text-white text-lg sm:text-xl mt-6 mb-8 max-w-lg leading-relaxed">{t("studio.heroLine")}</motion.p>
      <motion.div {...enter(0.28)} className="flex flex-col sm:flex-row flex-wrap gap-3 items-stretch sm:items-center max-w-lg">
        <Link to="/contact" data-testid="hero-cta-btn" className="studio-button studio-button-light">{t("hero.cta")}<ArrowUpRight size={18} /></Link>
        <Link to="/services" data-testid="hero-services-btn" className="studio-button studio-button-outline">{t("hero.services")}</Link>
      </motion.div>
      <motion.div {...enter(0.36)} className="hero-mobile-link">
        <Link to="/services?category=automotive" data-testid="hero-mobile-detailing" className="flex items-start gap-3 text-white group">
          <CarFront className="w-5 h-5 shrink-0 mt-1 text-cyan-200" />
          <span className="min-w-0"><span className="block text-sm font-semibold">{t("studio.mobileTitle")}</span><span className="block text-xs text-slate-200 mt-1">{t("studio.mobileBadge")}</span></span>
          <ArrowUpRight className="w-5 h-5 shrink-0 ms-auto group-hover:-translate-y-1 transition-transform" />
        </Link>
      </motion.div>
    </div>
    <button type="button" data-testid="scroll-indicator" aria-label={t("studio.workTitle")} title={t("studio.workTitle")}
      onClick={() => document.querySelector('[data-testid="real-work-section"]')?.scrollIntoView({ behavior: reduced ? "auto" : "smooth" })}
      className="hero-scroll-control"><ArrowDown size={20} /></button>
  </section>;
}